/* ============================================================
   FARMAGENA / B2C Kozmetik — theme.js
   Vanilla JS: sepet (AJAX), çekmece, mobil menü, slider,
   varyant seçici, galeri, adet, çerez, favori, toast.
   ============================================================ */
(function () {
  "use strict";

  /* themeSettings <head>'deki satır içi script'te tanımlanır.
     Orada bir sorun olursa tema tamamen çökmesin diye burada güvenceye alıyoruz:
     tek bir eksik değer yüzünden sepet/çekmece olayları ölmemeli. */
  const TS = (window.themeSettings = window.themeSettings || {});

  const T = () => TS.strings || {};
  const money = (cents) => {
    try {
      if (window.Shopify && window.Shopify.formatMoney && TS.moneyFormat) {
        return window.Shopify.formatMoney(cents, TS.moneyFormat);
      }
      return (cents / 100).toLocaleString(TS.locale || "de-DE", {
        style: "currency",
        currency: TS.currency || "EUR",
      });
    } catch (e) {
      return (cents / 100).toFixed(2) + " €";
    }
  };

  /* ---------------- Toast ---------------- */
  function toast(message, type) {
    let el = document.querySelector(".toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "toast";
      document.body.appendChild(el);
    }
    el.className = "toast" + (type ? " toast--" + type : "");
    el.textContent = message;
    requestAnimationFrame(() => el.classList.add("is-visible"));
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove("is-visible"), 2200);
  }
  window.themeToast = toast;

  /* ---------------- Sepet (AJAX) ---------------- */
  const Cart = {
    async get() {
      const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      return r.json();
    },
    async add(items) {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items }),
      });
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        throw new Error(e.description || T().cartAddError || "Error");
      }
      return r.json();
    },
    async change(key, quantity) {
      const r = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      return r.json();
    },
  };

  function bump(el) {
    el.classList.remove("is-bump");
    void el.offsetWidth; // reflow — animasyon yeniden tetiklensin
    el.classList.add("is-bump");
    setTimeout(() => el.classList.remove("is-bump"), 520);
  }

  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      const changed = String(el.textContent).trim() !== String(count);
      el.textContent = count;
      el.hidden = count === 0;
      el.style.display = count === 0 ? "none" : "";
      if (changed && count > 0) bump(el);
    });
    const num = document.querySelector("[data-drawer-count]");
    const wrap = document.querySelector("[data-drawer-count-wrap]");
    if (num) num.textContent = count;
    if (wrap) wrap.hidden = count === 0;
  }

  /* Ücretsiz kargo ilerleme çubuğu — sunucudaki markup'ı yerinde günceller */
  function updateShippingBars(totalPrice) {
    document.querySelectorAll("[data-ship-bar]").forEach((bar) => {
      const threshold = parseInt(bar.getAttribute("data-threshold"), 10) || 0;
      if (!threshold) return;
      const remaining = threshold - totalPrice;
      const pct = Math.min(100, Math.round((totalPrice / threshold) * 1000) / 10);
      const fill = bar.querySelector("[data-ship-bar-fill]");
      const track = bar.querySelector("[data-ship-bar-track]");
      const label = bar.querySelector("[data-ship-bar-label]");
      if (fill) fill.style.width = pct + "%";
      if (track) track.setAttribute("aria-valuenow", Math.round(pct));
      bar.classList.toggle("is-reached", remaining <= 0);
      if (label) {
        label.textContent =
          remaining > 0
            ? String(T().freeShippingProgress || "").replace(/__AMOUNT__|\{\{\s*amount\s*\}\}/, money(remaining))
            : String(T().freeShippingReached || "");
      }
    });
  }

  /* Sepette zaten bulunan öneri ürünlerini gizle — ek istek yok.
     data-cx-max: çekmecede gösterilecek en fazla öneri (liste uzamasın) */
  function syncCrossSell(variantIds) {
    const inCart = new Set((variantIds || []).map(String));
    document.querySelectorAll("[data-cross-sell]").forEach((box) => {
      const max = parseInt(box.getAttribute("data-cx-max"), 10) || 0;
      let visible = 0;
      box.querySelectorAll("[data-cx-item]").forEach((item) => {
        const hide = inCart.has(item.getAttribute("data-cx-variant")) || (max > 0 && visible >= max);
        item.hidden = hide;
        if (!hide) visible++;
      });
      box.hidden = visible === 0;
    });
  }

  function cartVariantIdsFromDom() {
    return Array.from(document.querySelectorAll(".cart-item[data-variant-id]")).map((el) =>
      el.getAttribute("data-variant-id")
    );
  }

  function cdnThumb(url, w) {
    if (!url) return "";
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set("width", String(w));
      return u.href;
    } catch (e) {
      return url;
    }
  }

  /* Çekmece satırı — cart-drawer.liquid'deki markup ile birebir aynı */
  function drawerItemHtml(it) {
    const img = it.image
      ? `<img src="${cdnThumb(it.image, 160)}" alt="" loading="lazy" width="72" height="96">`
      : "";
    const brand = it.vendor ? `<p class="cart-item__brand">${escapeHtml(it.vendor)}</p>` : "";
    const variant =
      it.variant_title && it.variant_title.indexOf("Default") === -1
        ? `<p class="cart-item__variant">${escapeHtml(it.variant_title)}</p>`
        : "";
    return `
      <div class="cart-item cart-item--drawer" data-key="${it.key}" data-variant-id="${it.variant_id}">
        <a class="cart-item__media" href="${it.url}" tabindex="-1" aria-hidden="true">${img}</a>
        <div class="cart-item__main">
          ${brand}
          <a href="${it.url}"><p class="cart-item__title">${escapeHtml(it.product_title)}</p></a>
          ${variant}
          <div class="qty qty--sm" data-qty>
            <button type="button" data-qty-minus aria-label="${escapeHtml(T().decrease || "-")}">−</button>
            <input type="text" value="${it.quantity}" readonly aria-label="${escapeHtml(T().quantity || "")}">
            <button type="button" data-qty-plus aria-label="${escapeHtml(T().increase || "+")}">+</button>
          </div>
        </div>
        <div class="cart-item__side">
          <span class="price__current cart-item__price">${money(it.final_line_price)}</span>
          <button type="button" class="cart-item__remove" data-remove>${escapeHtml(T().remove || "×")}</button>
        </div>
      </div>`;
  }

  /* cartData verilirse ek istek atılmaz (change/add yanıtı yeniden kullanılır) */
  async function refreshDrawer(cartData) {
    const cart = cartData || (await Cart.get());
    updateCartCount(cart.item_count);
    updateShippingBars(cart.total_price);
    syncCrossSell((cart.items || []).map((i) => i.variant_id));

    const items = document.querySelector("[data-cart-drawer-items]");
    if (!items) return cart;
    const isEmpty = cart.item_count === 0;
    const empty = document.querySelector("[data-cart-drawer-empty]");
    const foot = document.querySelector("[data-cart-drawer-foot]");
    const bar = document.querySelector("[data-drawer-shipping]");
    const cx = document.querySelector("[data-drawer-cx]");
    if (empty) empty.hidden = !isEmpty;
    if (foot) foot.hidden = isEmpty;
    if (bar) bar.hidden = isEmpty;
    if (cx) cx.hidden = isEmpty;
    items.innerHTML = isEmpty ? "" : cart.items.map(drawerItemHtml).join("");

    const totalEl = document.querySelector("[data-cart-drawer-total]");
    if (totalEl) totalEl.textContent = money(cart.total_price);
    return cart;
  }

  /* Sepet sayfası — Section Rendering API ile sayfa yenilemeden tazele */
  async function refreshCartSection(cart) {
    const sec = document.querySelector("[data-cart-section]");
    if (!sec) return;
    const id = sec.getAttribute("data-section-id");
    try {
      const r = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(id)}`, {
        headers: { Accept: "application/json" },
      });
      const data = await r.json();
      const doc = new DOMParser().parseFromString(data[id] || "", "text/html");
      const fresh = doc.querySelector("[data-cart-section]");
      if (!fresh) throw new Error("section");
      sec.innerHTML = fresh.innerHTML;
    } catch (e) {
      window.location.reload();
      return;
    }
    if (cart) syncCrossSell((cart.items || []).map((i) => i.variant_id));
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  }

  /* ---------------- Çekmece aç/kapa ---------------- */
  let lastFocus = null;

  function openDrawer() {
    const drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    document.querySelector("[data-drawer-overlay]")?.classList.add("is-open");
    document.body.style.overflow = "hidden";
    const close = drawer.querySelector("[data-drawer-close]");
    if (close) requestAnimationFrame(() => close.focus());
  }

  function closeDrawer() {
    const drawer = document.querySelector("[data-cart-drawer]");
    if (drawer && !drawer.classList.contains("is-open")) return;
    drawer?.classList.remove("is-open");
    document.querySelector("[data-drawer-overlay]")?.classList.remove("is-open");
    document.body.style.overflow = "";
    if (lastFocus && document.contains(lastFocus)) {
      try {
        lastFocus.focus();
      } catch (e) {
        /* yoksay */
      }
    }
    lastFocus = null;
  }

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" && e.key !== "Esc") return;
    if (document.querySelector("[data-cart-drawer].is-open")) closeDrawer();
  });

  document.addEventListener("click", async (e) => {
    // Sepete ekle (kart + ürün sayfası)
    const addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn) {
      e.preventDefault();
      const id = addBtn.getAttribute("data-variant-id");
      if (!id) return;
      const qtyInput = addBtn.closest("[data-product-form]")?.querySelector("[data-qty] input");
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addBtn.disabled = true;
      const original = addBtn.innerHTML;
      try {
        await Cart.add([{ id: Number(id), quantity }]);
        addBtn.innerHTML = T().addedShort || "✓";
        addBtn.classList.add("btn--success");
        toast(T().added || "✓", "success");
        const onCartPage = !!document.querySelector("[data-cart-section]");
        const cart = await refreshDrawer();
        if (onCartPage) {
          await refreshCartSection(cart);
        } else if (TS.cartAction !== "page") {
          openDrawer();
        }
        setTimeout(() => {
          addBtn.innerHTML = original;
          addBtn.classList.remove("btn--success");
          addBtn.disabled = false;
        }, 1500);
      } catch (err) {
        toast(err.message || T().error || "!");
        addBtn.disabled = false;
      }
      return;
    }

    if (e.target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      if (TS.cartAction !== "page") {
        openDrawer();
        refreshDrawer();
      } else {
        window.location.href = (TS.routes && TS.routes.cart) || "/cart";
      }
      return;
    }
    if (e.target.closest("[data-drawer-close]") || e.target.closest("[data-drawer-overlay]")) {
      closeDrawer();
      return;
    }

    // Adet / kaldır — hem çekmece hem sepet sayfası (sayfa yenilenmez)
    const row = e.target.closest(".cart-item[data-key]");
    if (row) {
      const isRemove = !!e.target.closest("[data-remove]");
      const isPlus = !!e.target.closest("[data-qty-plus]");
      const isMinus = !!e.target.closest("[data-qty-minus]");
      if (isRemove || isPlus || isMinus) {
        e.preventDefault(); // sepet sayfasında bunlar <a href> — klasik gezinmeyi durdur
        if (row.classList.contains("is-busy")) return;

        const key = row.getAttribute("data-key");
        let newQty = 0;
        if (!isRemove) {
          const input = row.querySelector("[data-qty] input");
          const current = input ? parseInt(input.value, 10) || 1 : 1;
          newQty = Math.max(0, current + (isPlus ? 1 : -1));
        }

        const inPage = !!row.closest("[data-cart-section]");
        row.classList.add("is-busy");
        try {
          const cart = await Cart.change(key, newQty);
          if (inPage) {
            await refreshCartSection(cart);
            await refreshDrawer(cart);
          } else {
            await refreshDrawer(cart);
          }
        } catch (err) {
          row.classList.remove("is-busy");
          toast(T().error || "!");
        }
        return;
      }
    }

    // Favori (localStorage) — B2C: misafir favorileri tarayıcıda
    const favBtn = e.target.closest("[data-fav]");
    if (favBtn) {
      e.preventDefault();
      e.stopPropagation();
      const id = favBtn.getAttribute("data-fav");
      toggleFav(id, favBtn);
      return;
    }
  });

  /* Sepet sayfasında adet alanına elle yazılırsa — "Güncelle"ye basmadan uygula */
  document.addEventListener("change", async (e) => {
    const input = e.target.closest(".cart-lines .cart-item[data-key] [data-qty] input");
    if (!input) return;
    const row = input.closest(".cart-item[data-key]");
    if (!row || row.classList.contains("is-busy")) return;
    const newQty = Math.max(0, parseInt(input.value, 10) || 0);
    row.classList.add("is-busy");
    try {
      const cart = await Cart.change(row.getAttribute("data-key"), newQty);
      await refreshCartSection(cart);
      await refreshDrawer(cart);
    } catch (err) {
      row.classList.remove("is-busy");
      toast(T().error || "!");
    }
  });

  /* ---------------- Adet kutusu (ürün sayfası) ---------------- */
  document.addEventListener("click", (e) => {
    const box = e.target.closest("[data-qty]");
    if (!box || box.closest(".cart-item")) return;
    const input = box.querySelector("input");
    if (!input) return;
    let q = parseInt(input.value, 10) || 1;
    const min = parseInt(input.getAttribute("min") || "1", 10);
    if (e.target.closest("[data-qty-plus]")) q += 1;
    else if (e.target.closest("[data-qty-minus]")) q = Math.max(min, q - 1);
    input.value = q;
  });

  /* ---------------- Favoriler ---------------- */
  const FAV_KEY = "theme_favorites";
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || "[]"); } catch { return []; }
  }
  function toggleFav(id, btn) {
    let favs = getFavs();
    const on = favs.includes(id);
    if (on) favs = favs.filter((x) => x !== id);
    else favs.push(id);
    try { localStorage.setItem(FAV_KEY, JSON.stringify(favs)); } catch {}
    if (btn) btn.classList.toggle("is-active", !on);
    document.querySelectorAll(`[data-fav="${id}"]`).forEach((b) => b.classList.toggle("is-active", !on));
    toast(on ? (T().favRemoved || "–") : (T().favAdded || "+"));
  }
  function markFavs() {
    const favs = getFavs();
    favs.forEach((id) => document.querySelectorAll(`[data-fav="${id}"]`).forEach((b) => b.classList.add("is-active")));
  }

  /* ---------------- Mobil menü ---------------- */
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-menu-open]")) {
      document.querySelector("[data-mobile-menu]")?.classList.add("is-open");
      document.querySelector("[data-menu-overlay]")?.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    if (e.target.closest("[data-menu-close]") || e.target.closest("[data-menu-overlay]")) {
      document.querySelector("[data-mobile-menu]")?.classList.remove("is-open");
      document.querySelector("[data-menu-overlay]")?.classList.remove("is-open");
      document.body.style.overflow = "";
    }
    // Mobil menüde alt menü aç/kapa
    const sub = e.target.closest("[data-submenu-toggle]");
    if (sub) {
      sub.closest(".mobile-menu__item")?.classList.toggle("is-open");
    }
  });

  /* ---------------- Ürün galerisi ---------------- */
  document.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    const gallery = thumb.closest("[data-gallery]");
    const main = gallery.querySelector("[data-gallery-main] img");
    const full = thumb.getAttribute("data-full");
    /* srcset MUSS entfernt werden, sonst gewinnt es gegen den neuen src
       und das Bild wechselt nicht. */
    if (main && full) { main.removeAttribute("srcset"); main.removeAttribute("sizes"); main.src = full; }
    gallery.querySelectorAll("[data-gallery-thumb]").forEach((t) => t.classList.remove("is-active"));
    thumb.classList.add("is-active");
  });

  /* ---------------- Accordion ---------------- */
  document.addEventListener("click", (e) => {
    const head = e.target.closest("[data-accordion-head]");
    if (!head) return;
    const item = head.closest(".product-accordion__item");
    const body = item.querySelector(".product-accordion__body");
    const open = item.classList.toggle("is-open");
    body.style.display = open ? "block" : "none";
    const icon = head.querySelector("[data-accordion-icon]");
    if (icon) icon.style.transform = open ? "rotate(180deg)" : "";
  });

  /* ---------------- Koleksiyon filtreleri ----------------
     Shopify, boş ya da geçersiz bir filtre parametresi gördüğünde
     (ör. "?filter.v.price.gte=") koleksiyon sayfasını 404 ile yanıtlar.
     GET formu boş alanları da URL'e yazdığı için, kullanıcı fiyat
     kutularından yalnızca birini doldurunca sayfa 404'e düşüyordu.
     Aşağıdaki temizleyici, gönderimden hemen önce boş alanların "name"
     özniteliğini kaldırır — adsız alan URL'e hiç yazılmaz. Ayrıca
     Almanca klavyeden gelen "49,90" gibi virgüllü girişi noktaya çevirir.
     NOT: Fiyat kutularında "pattern" özniteliği KULLANILMAZ. Tarayıcı
     doğrulaması submit olayından ÖNCE çalışır; " 75 " ya da "49,90 €"
     gibi bir girişte formu tamamen bloke eder ve temizleyici hiç
     çalışamaz. Temizliği tek yerde, burada yapıyoruz. */
  function normalizeDecimal(value) {
    /* "49,90" → "49.9" · "1.234,50" → "1234.5" · " 75 € " → "75" */
    let raw = String(value || "").replace(/\s/g, "");
    if (raw.indexOf(",") > -1) raw = raw.replace(/\./g, "").replace(",", ".");
    raw = raw.replace(/[^0-9.]/g, "");
    const parts = raw.split(".");
    if (parts.length > 2) raw = parts.shift() + "." + parts.join("");
    const num = parseFloat(raw);
    return raw === "" || isNaN(num) || num < 0 ? "" : String(num);
  }
  function sanitizeFacets(form) {
    if (!form) return;
    /* Önceki denemede adı alınmış alanları geri ver */
    form.querySelectorAll("input[data-name]").forEach((el) => {
      el.setAttribute("name", el.getAttribute("data-name"));
      el.removeAttribute("data-name");
    });
    form.querySelectorAll("input").forEach((el) => {
      if (el.type === "checkbox" || el.type === "radio") return;
      if (el.getAttribute("inputmode") === "decimal") el.value = normalizeDecimal(el.value);
    });
    /* Min > Max girildiyse yer değiştir: aksi halde sonuç hep boş çıkar */
    const lo = form.querySelector('input[name$=".gte"],input[data-name$=".gte"]');
    const hi = form.querySelector('input[name$=".lte"],input[data-name$=".lte"]');
    if (lo && hi && lo.value !== "" && hi.value !== "" && parseFloat(lo.value) > parseFloat(hi.value)) {
      const t = lo.value;
      lo.value = hi.value;
      hi.value = t;
    }
    /* Boş alanın adını kaldır: adsız alan URL'e hiç yazılmaz → 404 yok */
    form.querySelectorAll("input").forEach((el) => {
      if (el.type === "checkbox" || el.type === "radio") return;
      if (!el.value && el.getAttribute("name")) {
        el.setAttribute("data-name", el.getAttribute("name"));
        el.removeAttribute("name");
      }
    });
  }
  /* Kutudan çıkınca girilen değeri düzelt: müşteri ne gönderdiğini görsün.
     blur köpürmez, bu yüzden yakalama (capture) aşamasında dinliyoruz. */
  document.addEventListener(
    "blur",
    (e) => {
      const el = e.target;
      if (!el || !el.closest) return;
      if (el.getAttribute && el.getAttribute("inputmode") === "decimal" && el.closest("[data-facets-form]")) {
        el.value = normalizeDecimal(el.value);
      }
    },
    true
  );
  /* Gönder tuşu / Enter: submit olayı köpürür, varsayılan davranıştan
     hemen önce temizleriz (form verisi olay bittikten sonra toplanır). */
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("[data-facets-form]");
    if (form) sanitizeFacets(form);
  });
  /* Onay kutusu / sıralama: form.submit() submit olayını tetiklemez,
     bu yüzden önce elle temizleyip sonra gönderiyoruz. */
  document.addEventListener("change", (e) => {
    const auto = e.target.closest("[data-facets-auto]");
    if (!auto || !auto.form) return;
    sanitizeFacets(auto.form);
    auto.form.submit();
  });

  /* ---------------- Varyant seçici ---------------- */
  window.initVariantPicker = function (root, variants) {
    if (!root) return;
    const container = root.closest("[data-product-form]") || document;
    const pills = root.querySelectorAll("[data-variant-option]");
    const priceEl = container.querySelector("[data-variant-price]");
    const compareEl = container.querySelector("[data-variant-compare]");
    const addBtn = container.querySelector("[data-add-to-cart]");
    const selected = {};

    function findVariant() {
      return variants.find((v) => v.options.every((opt, i) => selected[i] === opt));
    }
    const hiddenInput = root.closest("[data-product-form]")?.querySelector("[data-variant-input]");
    function update() {
      const v = findVariant();
      if (!v) return;
      if (hiddenInput) hiddenInput.value = v.id;
      if (addBtn) {
        addBtn.setAttribute("data-variant-id", v.id);
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available
          ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> ' + (T().addToCart || '')
          : (T().soldOut || "–");
      }
      if (priceEl) priceEl.textContent = money(v.price);
      const stickyPrice = document.querySelector("[data-variant-price-sticky]");
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
    }
    pills.forEach((pill) => {
      pill.addEventListener("click", () => {
        const gi = Number(pill.getAttribute("data-option-index"));
        selected[gi] = pill.getAttribute("data-variant-option");
        root.querySelectorAll(`[data-option-index="${gi}"]`).forEach((p) => p.classList.remove("is-active"));
        pill.classList.add("is-active");
        update();
      });
    });
    // İlk mevcut varyantı seç
    root.querySelectorAll("[data-option-group]").forEach((group) => {
      const first = group.querySelector("[data-variant-option]");
      if (first) first.click();
    });
  };

  /* ---------------- Slideshow ---------------- */
  function initSlideshows() {
  document.querySelectorAll("[data-slideshow]").forEach((ss) => {
    if (ss.dataset.ssInit) return;
    ss.dataset.ssInit = "1";
    const track = ss.querySelector("[data-slideshow-track]");
    const slides = track ? track.children.length : 0;
    if (slides <= 1) return;
    let i = 0;
    const dots = ss.querySelectorAll("[data-slideshow-dot]");
    const go = (n) => {
      i = (n + slides) % slides;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, di) => d.classList.toggle("is-active", di === i));
    };
    ss.querySelector("[data-slideshow-next]")?.addEventListener("click", () => go(i + 1));
    ss.querySelector("[data-slideshow-prev]")?.addEventListener("click", () => go(i - 1));
    dots.forEach((d, di) => d.addEventListener("click", () => go(di)));
    const interval = Number(ss.getAttribute("data-autoplay")) || 0;
    if (interval > 0) {
      /* Autoplay läuft nur, wenn der Slider sichtbar ist und der Tab aktiv ist.
         Spart CPU/Akku und verhindert Layout-Arbeit im Hintergrund. */
      let timer = null, inView = true, hover = false;
      const start = () => { if (!timer) timer = setInterval(() => go(i + 1), interval * 1000); };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const sync = () => { (inView && !hover && !document.hidden) ? start() : stop(); };
      ss.addEventListener("mouseenter", () => { hover = true; sync(); });
      ss.addEventListener("mouseleave", () => { hover = false; sync(); });
      document.addEventListener("visibilitychange", sync);
      if ("IntersectionObserver" in window) {
        new IntersectionObserver((ents) => { inView = ents[0].isIntersecting; sync(); }, { threshold: 0.1 }).observe(ss);
      } else {
        sync();
      }
    }
  });
  }

  /* ---------------- Çerez onayı ---------------- */
  const COOKIE_KEY = "cookie_consent";
  function initCookie() {
    const banner = document.querySelector("[data-cookie-banner]");
    if (!banner) return;
    /* "1" = angenommen, "0" = abgelehnt. Beides ist eine Entscheidung →
       Banner nicht erneut zeigen. Nur wenn nichts gespeichert ist, erscheint es. */
    let decided = false;
    try { decided = localStorage.getItem(COOKIE_KEY) !== null; } catch {}
    if (!decided) banner.classList.add("is-visible");
    banner.querySelectorAll("[data-cookie-accept]").forEach((b) =>
      b.addEventListener("click", () => {
        try { localStorage.setItem(COOKIE_KEY, "1"); } catch {}
        banner.classList.remove("is-visible");
      })
    );
    /* TTDSG §25 / DSGVO: Ablehnen tatsächlich speichern — Banner schließt,
       aber es wird KEINE Einwilligung erteilt (Wert "0"). */
    banner.querySelectorAll("[data-cookie-decline]").forEach((b) =>
      b.addEventListener("click", () => {
        try { localStorage.setItem(COOKIE_KEY, "0"); } catch {}
        banner.classList.remove("is-visible");
      })
    );
  }

  /* ---------------- Arama önizleme (predictive) ---------------- */
  document.querySelectorAll("[data-search-input]").forEach((input) => {
    let t;
    const box = input.closest("[data-search]")?.querySelector("[data-search-results]");
    input.addEventListener("input", () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (!box) return;
      if (q.length < 2) { box.hidden = true; box.innerHTML = ""; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const data = await r.json();
          const products = (data.resources?.results?.products) || [];
          if (!products.length) { box.hidden = true; return; }
          box.innerHTML = products
            .map((p) => `<a href="${p.url}" class="search-suggest__item"><img src="${p.image || ""}" alt="" width="40" height="40"><span>${escapeHtml(p.title)}</span></a>`)
            .join("");
          box.hidden = false;
        } catch { box.hidden = true; }
      }, 250);
    });
    document.addEventListener("click", (e) => {
      if (box && !input.closest("[data-search]").contains(e.target)) box.hidden = true;
    });
  });

  /* ---------------- Dönen kelimeler (hero) ---------------- */
  function initRotators() {
    document.querySelectorAll("[data-rotator]").forEach((el) => {
      let words = [];
      try { words = JSON.parse(el.getAttribute("data-rotator") || "[]"); } catch {}
      words = words.map((w) => String(w).trim()).filter(Boolean);
      if (words.length < 2) return;
      if (el.dataset.rotInit) return;
      el.dataset.rotInit = "1";
      const span = el.querySelector(".rot-word") || el;
      let i = 0;
      const interval = Number(el.getAttribute("data-interval")) || 2600;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      /* Wie beim Slider: nur animieren, wenn sichtbar und Tab aktiv. */
      const tick = () => {
        span.classList.add("is-out");
        setTimeout(() => {
          i = (i + 1) % words.length;
          span.textContent = words[i];
          span.classList.remove("is-out");
        }, 420);
      };
      let timer = null, inView = true;
      const start = () => { if (!timer) timer = setInterval(tick, interval); };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const sync = () => { (inView && !document.hidden) ? start() : stop(); };
      document.addEventListener("visibilitychange", sync);
      if ("IntersectionObserver" in window) {
        new IntersectionObserver((ents) => { inView = ents[0].isIntersecting; sync(); }, { threshold: 0 }).observe(el);
      } else {
        sync();
      }
    });
  }

  /* ---------------- Mobil yapışkan sepete-ekle ---------------- */
  function initStickyAtc() {
    const bar = document.querySelector("[data-sticky-atc]");
    if (!bar || bar.dataset.init) return;
    bar.dataset.init = "1";
    const onScroll = () => {
      const show = window.scrollY > 480;
      bar.classList.toggle("is-visible", show);
      /* CSS --bottom-bar-h aktivieren: schwebende Buttons (WhatsApp, Sommelier,
         Cookie-Banner) rücken nach oben, solange die Leiste sichtbar ist. */
      document.body.classList.toggle("has-bottom-bar", show);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    bar.querySelector("[data-sticky-add]")?.addEventListener("click", () => {
      const main = document.querySelector("[data-product-form] [data-add-to-cart]");
      if (main && !main.disabled) main.click();
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  function initReveal() {
    const els = document.querySelectorAll("[data-animate]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("in-view")); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add("in-view"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach((e) => io.observe(e));
  }

  /* ---------------- Başlat ---------------- */
  function boot() {
    markFavs();
    initRotators();
    initReveal();
    initSlideshows();
    initStickyAtc();
  }
  document.addEventListener("DOMContentLoaded", () => {
    boot();
    initCookie();
    /* Sayfa açılışında /cart.js isteği YOK — çekmece sunucuda render edilir.
       Öneriler doğrudan DOM'daki sepet satırlarına göre filtrelenir. */
    syncCrossSell(cartVariantIdsFromDom());
  });
  /* Geri/ileri tuşu (bfcache): önbellekten dönen sayfada sepet bayat olabilir */
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) refreshDrawer();
  });
  /* Tema editörü: section yeniden çizilince animasyon/slider/rotator yeniden başlar */
  document.addEventListener("shopify:section:load", () => boot());
  document.addEventListener("shopify:section:select", () => boot());
  document.addEventListener("shopify:block:select", () => boot());
})();
